import { NComment, RSetState, EGetComment, EPostCommentReply, EPostComment } from './constants'

import { getComment, postComment, postCommentReply } from '../services'
export default {
  namespace: NComment,
  state: {
    comment: {
      data: [],
    },
    pager: 1,
    loading: false,
  },
  reducers: {
    [RSetState](state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
  effects: {
    async [EGetComment]({ payload }, { call, reducer, select }) {
      let { id, page } = payload
      let data = await call(getComment, { id, page: page || 1, perPage: 6 })
      reducer(RSetState, { comment: data })
    },
    async [EPostComment]({ payload }, { call, reducer, select, effect }) {
      let { update, id, content } = payload
      await call(postComment, { id, content })
      if (update) {
        effect(NComment, EGetComment, { id })
      }
    },
    async [EPostCommentReply]({ payload }, { call, reducer, select, effect }) {
      let { infoID } = payload
      await call(postCommentReply, payload)
      if (infoID) {
        effect(NComment, EGetComment, { id: infoID })
      }
    },
  },
}
